import { PromosStylesSchema } from './Promos.styles';

export const promosStyles: PromosStylesSchema = {
  container: {},
  body: {
    mt: '-3',
  },
};
